export default "__VITE_ASSET__PFa9Y2Hx__"